// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"328":"61881619","364":"8e5e4ae8","367":"9f79a7c3","388":"07c0e138","417":"af988e54","444":"d311485e","703":"bba110df","981":"f2daac2b"}[chunkId] + ".chunk.js";
};